/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useEffect } from 'react';

const useAngelAIWidget = () => {
  useEffect(() => {
    const jsUrl = process.env.REACT_APP_ANGELAI_WIDGET_JS;
    const cssUrl = process.env.REACT_APP_ANGELAI_WIDGET_CSS;
    if (!jsUrl || !cssUrl) return;
    if (document.getElementById('angelai-widget')) return;

    const cacheBust = `?v=${Date.now()}`;

    const link = document.createElement('link');
    link.id = 'angelai-widget-styles';
    link.rel = 'stylesheet';
    link.href = cssUrl + cacheBust;
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.id = 'angelai-widget';
    script.src = jsUrl + cacheBust;
    script.setAttribute('comicBubbleBackground', '#ffffffe6');
    script.setAttribute('comicBubbleBorderColor', '#FF541C60');
    script.setAttribute('userType', 'angelailife');
    document.body.appendChild(script);
  }, []);
};

export default useAngelAIWidget;
